export enum HIERARCHY_SECTION {
  familyDocuments = 'Family Documents',
  personalDocuments = 'Personal Legal Documents',
  otherDocuments = 'Other Sensitive Documents',
  passwords = 'Passwords and Combinations',
  taxes = 'Taxes',
}
